import { STORAGE_KEY_ENUM } from 'enums';
import { PermissionsState } from './types';
import permissionsActions from './actions';
import { createSlice } from '@reduxjs/toolkit';

const initialState: PermissionsState = {
  error: null,
  loading: false,
  allShowBooks: false,
  updateFullBook: false,
  updateCompanyName: false,
  permissionsInitialized: false,
  permissionCodes: [STORAGE_KEY_ENUM.NON_INITIALIZED],
};

export const permissionsSlice = createSlice({
  initialState,
  name: 'permissions',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(permissionsActions.initialize.pending, (state) => {
      state.error = null;
      state.loading = true;
    });

    builder.addCase(
      permissionsActions.initialize.fulfilled,
      (state, { payload: { permissionCodes, allShowBooks, updateFullBook, updateCompanyName } }) => {
        state.error = null;
        state.loading = false;
        state.permissionsInitialized = true;
        state.allShowBooks = allShowBooks;
        state.updateFullBook = updateFullBook;
        state.updateCompanyName = updateCompanyName;
        state.permissionCodes = permissionCodes;
      }
    );

    builder.addCase(permissionsActions.initialize.rejected, (state, { error }) => {
      state.error = error;
      state.loading = false;
    });
  },
});

export default permissionsSlice.reducer;
